import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input, InputNumber, Select } from 'antd';
import { READWITH, QueryOrder, QueryDetail, errorCatch } from 'fennec-ui'



import { useState } from 'react';
import InputWithSearchModal from '../../components/InputWithSearchModal';
import UserFilter from '../UserFilter';
import UserSelector from '../UserSelector';

const { Option } = Select;

export default function KategoriiUchastnikovNaMeropriyatiyakhUpdate(props) {
    const { auth, form, object } = props;
    const dispatch = useDispatch();

    const [kategoriyaUchastnikov, setKategoriyaUchastnikov] = useState([]);
    const [tantsevalnayaDistsiplina, setTantsevalnayaDistsiplina] = useState([]);
    useEffect(() => {
        form.resetFields();
        READWITH(auth, "KategoriiUchastnikov", [
            QueryOrder("id", "ASC"),
            QueryDetail("model")
        ], ({ data }) => {
            setKategoriyaUchastnikov(data);
        }, errorCatch);

        READWITH(auth, "TantsevalnieDistsiplini", [
            QueryOrder("id", "ASC"),
            QueryDetail("model")
        ], ({ data }) => {
            setTantsevalnayaDistsiplina(data);
        }, errorCatch);
    }, []);
    const kategoriyaUchastnikovOptions = kategoriyaUchastnikov?.map((i) => <Option key={i.ID} item={i} value={i.ID} label={i.nazvanie}>{i.nazvanie}</Option>);
    const tantsevalnayaDistsiplinaOptions = tantsevalnayaDistsiplina?.map((i) => <Option key={i.ID} item={i} value={i.ID} label={i.nazvanie}>{i.nazvanie}</Option>);
    return (
        <>
            <Form
                form={props.form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object,
                    kurator: object?.kurator?.user
                }}
            >
                <Form.Item label={"Танцевальная дисциплина"}
                    name="tantsevalnayaDistsiplinaID"
                    rules={[
                        { required: true, message: 'Пожалуйста, введите танцевальную дисциплину!' }
                    ]}
                >
                    <Select
                        disabled
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {tantsevalnayaDistsiplinaOptions}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"kategoriyaUchastnikovID"}
                    label={"Категория участников"}
                    rules={[{ required: true, message: 'Укажите категорию участников!' }]}
                >
                    <Select
                        disabled
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {kategoriyaUchastnikovOptions}
                    </Select>
                </Form.Item>
                <Form.Item label="Сокращенное наименование"
                    name="shortName"
                    rules={[{ required: false, message: 'Пожалуйста, ввeдите сокращенное наименование!' },
                    { max: 15, message: 'Значение должно быть не более 15 символов!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={"kurator"}
                    label={"Куратор"}
                    rules={[{ required: false, message: 'Укажите куратора!' }]}
                >
                    <InputWithSearchModal valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{}}
                        searchForm={UserFilter}
                        selectForm={UserSelector} />
                </Form.Item>
            </Form>
        </>
    );
}
